import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TWebsocketScriptSettings } from '../../../../../interface/interfaces';

interface IInitialState {
    scriptVersion: TWebsocketScriptSettings[]
}


const initialState: IInitialState = {
    scriptVersion: [],
};

const websocketScriptSettingsSlice = createSlice({
    name: 'websocketScriptSettings',
    initialState,
    reducers: {
        saveScriptSettings: (state: IInitialState, action: PayloadAction<TWebsocketScriptSettings[]>) => {
            state.scriptVersion = action.payload;
        },

        removeScriptSettings: (state: IInitialState) => {
            state.scriptVersion = [];
        },
    },
});

export default websocketScriptSettingsSlice.reducer;
export const { saveScriptSettings, removeScriptSettings } = websocketScriptSettingsSlice.actions;
